module.exports = __webpack_public_path__ + "static/media/6 3 octopus newschool tattoo color tentacles legsleeve tattoo.1280x1707.49c15063.webp";